import { render } from "./flightinfo.vue?vue&type=template&id=6c827b38"
import script from "./flightinfo.vue?vue&type=script&lang=js"
export * from "./flightinfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__